module.exports = __webpack_public_path__ + "static/media/149.975e36e5.jpg";